import UserRepository from '../../apis/repositories/UserRepository'
import AdminRepository from '../repositories/AdminRepository'
import { User, UserAuthType } from '../types'
import { LogErrorMessage, LogMessage } from './LoggerService'

const getUser = async (userId: string) => {
  try {
    return await UserRepository.getUser(userId)
  } catch (error) {
    LogErrorMessage('getUser', (error as Error).stack ?? String(error))
    throw error
  }
}

const getUserByCognitoId = async (cognitoId: string) => {
  try {
    return await UserRepository.getUserByCognitoId(cognitoId)
  } catch (error) {
    LogErrorMessage('getUserByCognitoId', (error as Error).stack ?? String(error))
    throw error
  }
}

const getPagedUsers = async (pageNumber: number, pageSize: number, authType: UserAuthType | null) => {
  try {
    return await AdminRepository.getPagedUsers(pageNumber, pageSize, authType)
  } catch (error) {
    LogErrorMessage('getPagedUsers', (error as Error).stack ?? String(error))
    throw error
  }
}

const editUser = async (user: User) => {
  try {
    await LogMessage('editUser', user)

    return await AdminRepository.postUser(user)
  } catch (error) {
    LogErrorMessage('editUser', (error as Error).stack ?? String(error))
    throw error
  }
}

export { getUser, getUserByCognitoId, getPagedUsers, editUser }
